import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { ReactElement } from "react";
import { VesselParticulars } from "./vessel-info/vesselParticulars";

export const VesselInformation = (): ReactElement => {
    return (
        <div>
            <VesselParticulars />
        </div>
    );
};
